<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke-width="2" stroke="white" class="size-10 block md:hidden"
  (click)="showMenu = true">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
</svg>

<div class="absolute z-9999 left-0 top-0 w-[100vw] h-[100vh]"
  [class.hidden]="!showMenu"
  [class.block]="showMenu">
  <app-menu class="w-full h-full" (onClose)="showMenu = false"></app-menu>
</div>
